import { api } from "core/axios/axios";
import type { IIdentity, IRawIdentityResponse, IIdentityListResult } from "./types";

export async function identityManagementRes() {
    return api.get("identitymanagement");
}


function normalizeIdentities(input: IRawIdentityResponse): IIdentity[] {
    if (!input || typeof input !== "object") return [];

    return Object.keys(input).map((k) => {
        const raw = input[k];

        // Cast status to allowed union, fallback to "Pending"
        const safeStatus: IIdentity["status"] =
            raw.status === "Pending" || raw.status === "Failed" || raw.status === "Success"
                ? raw.status
                : "Pending";

        return {
            id: k,
            email: raw.email,
            friendlyName: raw.friendlyName,
            status: safeStatus,
        };
    });
}


export async function fetchIdentities(): Promise<IIdentityListResult> {
    const { data } = await api.get<IRawIdentityResponse>("identitymanagement");
    const items = normalizeIdentities(data);
    return { items, total: items.length };
}

export async function deleteIdentity(email: string) {
    return api.delete("identitymanagement?email=" + email);
}

export async function refreshIdentity(email: string) {
    return api.put("identitymanagement", { email });
}

export async function addIdentityForVerification(body: { email: string; friendlyName: string }) {
    return api.post("identitymanagement", body);
}